/* eslint-disable @typescript-eslint/unbound-method */
import { inject } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { FormBuilder } from '@angular/forms';

export const vendorReviewQrForm = (
    fb: NonNullableFormBuilder = inject(FormBuilder).nonNullable,
) => {
    return fb.group({
        name: [{ value: '', disabled: true }],
        qrCodeUrl: [''],
        expirationDate: [{ value: '', disabled: true }],
    });
};

export type VendorReviewQrForm = ReturnType<typeof vendorReviewQrForm>;
